import React from 'react';

import { API, Logger, graphqlOperation } from 'aws-amplify';
import { getExecutionInputLog } from '../../../graphql/queries';

const logger = new Logger('useExecutionInputLog');

function reducer(state, action) {
  switch (action.type) {
    case 'INIT':
      return { 
        ...state,
        loading: true,
        error: false,
      };
    case 'ERROR':
      return { 
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'APPEND':
      logger.debug(`EXECUTION INPUT LOG APPEND: `,action.payload, state);
      return { 
        ...state,
        nextBackwardToken: action.payload.nextBackwardToken,
        nextForwardToken: action.payload.nextForwardToken,
        loading: state.nextForwardToken!==action.payload.nextForwardToken,
        logEvents: [...state.logEvents, ...action.payload.events] 
      };
    case 'ABORT':
      return { 
        ...state,
        loading: false,
        error: false,
        truncated: true,
      };
    default:
      return state;
  }
}

export const useExecutionInputLogCloudWatch = (props) => {

  const { executionId, inputUri } = props;

  const [state, dispatch] = React.useReducer(reducer, { 
    logEvents: [], 
    loading: true,
    error: null,
    truncated: false,
    nextBackwardToken: null,
    nextForwardToken: null,
  });

  const fetchLogPages = async (variables) => {
    
    let hasMore=true;
    let maxPages=10;
    let page=0;
    let nextToken=null;
    
    while(hasMore && page<maxPages) {
      //logger.debug("EXECUTION INPUT LOG PAGE = ", page, nextToken);
      page+=1;
      if(nextToken) {
        variables['nextToken']=nextToken;
      }

      try {
        const response = await API.graphql(graphqlOperation(getExecutionInputLog,variables));
        if(response.errors) {
          dispatch({ type: 'ERROR', payload: response.errors[0].message});
        } else {
          const log = response.data.getExecutionInputLog;
          dispatch({ type: 'APPEND', payload: log });
          if(nextToken!==log.nextForwardToken) {
            nextToken=log.nextForwardToken;
            if(page>=maxPages) {
              dispatch({ type: 'ABORT' });
            }
          } else {
            hasMore=false;
          }
        }
      } catch(error) {
        dispatch({ type: 'ERROR', payload: error});
        hasMore=false;
      }
    }
  };

  React.useEffect(() => {
    const variables = {
      executionId,
      inputUri,
      limit: 1000,
    };

    fetchLogPages(variables);

    return () => { 
      logger.debug("useExecutionInputLog cleanup!");
    };

  }, [executionId, inputUri]);
  
  return { 
    logEvents: state.logEvents, 
    loading: state.loading, 
    error: state.error,
    truncated: state.truncated,
  };

};
